import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ReactiveFormsModule } from '@angular/forms'
import { SharedPolymorpheusModule } from '@alliance/shared/polymorpheus'

import { SantaDropDownModule } from '@alliance/santa/drop-down'
import { SantaSelectComponent } from './select.component'
import { SharedPipesContextToImplicitModule } from '@alliance/shared/pipes/context-to-implicit'

@NgModule({
  imports: [CommonModule, ReactiveFormsModule, SharedPolymorpheusModule, SantaDropDownModule, SharedPipesContextToImplicitModule],
  declarations: [SantaSelectComponent],
  exports: [SantaSelectComponent]
})
export class SantaSelectModule {}
